import { type PropsWithChildren } from 'react';

import { Switch, type SwitchProps } from '@air/primitive-switch';

export type SharePrivateContentPermissionToggleProps = Pick<
  SwitchProps,
  'checked' | 'disabled' | 'id' | 'isLoading' | 'onCheckedChange'
> & {
  label: string;
  dataTestId?: string;
  labelTestId?: string;
};

export const SharePrivateContentPermissionToggle = ({
  checked,
  disabled,
  id,
  isLoading,
  label,
  onCheckedChange,
  children,
  dataTestId,
  labelTestId,
}: PropsWithChildren<SharePrivateContentPermissionToggleProps>) => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="mt-1 flex items-center">
        <label className="mr-2 text-14 text-grey-12" data-testid={labelTestId || 'LABEL'} htmlFor={id}>
          {label}
        </label>
        {children}
      </div>
      <Switch
        checked={checked}
        data-id={id}
        disabled={disabled}
        id={id}
        isLoading={isLoading}
        onCheckedChange={onCheckedChange}
        data-testid={dataTestId || 'SWITCH'}
      />
    </div>
  );
};
